import LegalPage from "@/components/LegalPage";
import { LEGAL_LAST_UPDATED } from "@/data/legal";

const sections = [
  {
    h: "1. What Are Cookies?",
    blocks: [
      { type: "p", text: "Cookies are small text files that are stored on your computer, tablet or mobile device when you visit our website. They help the website function properly and improve your browsing experience." },
    ],
  },
  {
    h: "2. How We Use Cookies",
    blocks: [
      { type: "p", text: "School Smile Australia uses cookies to:" },
      { type: "ul", items: [
        "Ensure the website functions correctly.",
        "Improve website performance and user experience.",
        "Remember your preferences.",
        "Analyse website traffic and visitor behaviour.",
        "Help protect the security of our website.",
      ]},
    ],
  },
  {
    h: "3. Types of Cookies We Use",
    blocks: [
      { type: "p", text: "Essential Cookies" },
      { type: "p", text: "These cookies are necessary for the website to operate and cannot usually be disabled." },
      { type: "p", text: "Analytics Cookies" },
      { type: "p", text: "These cookies help us understand how visitors use our website so we can improve its performance and content." },
      { type: "p", text: "We may use services such as Google Analytics to collect anonymous information about website usage." },
      { type: "p", text: "Functional Cookies" },
      { type: "p", text: "These cookies remember your preferences, such as language or display settings, to improve your experience." },
    ],
  },
  {
    h: "4. Managing Cookies",
    blocks: [
      { type: "p", text: "Most web browsers allow you to:" },
      { type: "ul", items: [
        "View stored cookies.",
        "Delete cookies.",
        "Block cookies.",
        "Disable some or all cookies.",
      ]},
      { type: "p", text: "Please note that disabling cookies may affect the functionality of certain parts of our website." },
    ],
  },
  {
    h: "5. Third-Party Services",
    blocks: [
      { type: "p", text: "Our website may use third-party services such as:" },
      { type: "ul", items: [
        "Google Analytics",
        "Google Maps",
        "Google Forms",
        "YouTube",
      ]},
      { type: "p", text: "These services may use their own cookies and are governed by their respective privacy policies." },
    ],
  },
  {
    h: "6. Changes to This Policy",
    blocks: [
      { type: "p", text: "We may update this Cookies Policy from time to time. Any changes will be published on this page with an updated revision date." },
    ],
  },
];

const Cookies = () => {
  if (typeof document !== "undefined") document.title = "Cookies Policy — School Smiles Australia";
  return (
    <LegalPage
      title="Cookies Policy"
      kicker="Legal"
      effectiveDate="16 August 2026"
      lead="This Cookies Policy explains how School Smile Australia uses cookies and similar technologies on our website."
      sections={sections}
      lastUpdated={LEGAL_LAST_UPDATED}
    />
  );
};

export default Cookies;
